import { useState } from 'react';
import { Title } from 'components/Title';

export default function PrivacypolicyPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="PrivacypolicyPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                {/* <Title title="PrivacyPolicy"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} /> */}
                <div className="">
                    <div className="container mx-auto">
                        <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6">
                            <Title 
                            title="Privacy Policy" 
                            titleClass="text-2xl font-bold text-primary mb-4"
                            separator={false}
                            />
                            <div className="text-gray-800 leading-7 space-y-4">
                                <p>
                                This privacy policy (the "PRIVACY POLICY") applies to your use of the website of <strong>NDB Pay</strong> hosted at <strong>https://ndbpay.in</strong>, the Services (as defined under the NDB Pay "Terms of Use") and NDB Pay applications on mobile platforms (Android, Blackberry, Windows Phone, iOS etc.) (collectively ("NDB Pay" or "WEBSITE")), but does not apply to any third-party websites that may be linked to them, or any relationships you may have with the businesses listed on NDB Pay.
                                </p>
                                <p>
                                The terms "WE", "OUR" and "US" refer to NDB Pay and the terms "YOU", "YOUR" and "USER" refer to you, as a user of NDB Pay. The term "PERSONAL INFORMATION" means information that you provide to us that personally identifies you to be contacted or identified, such as your name, phone number, email address, and any other data that is tied to such information. Our practices and procedures in relation to the collection and use of Personal Information have been set-out below in order to ensure safe usage of the Website for you.
                                </p>
                                <p>
                                We have implemented reasonable security practices and procedures that are commensurate with the information assets being protected and with the nature of our business. While we try our best to provide security that is better than the industry standards, because of the inherent vulnerabilities of the internet, we cannot ensure or warrant complete security of all information that is being transmitted to us by you.
                                </p>
                                <p>
                                By visiting this Website, you agree and acknowledge to be bound by this Privacy Policy and you hereby consent that we will collect, use, process and share your Personal Information in the manner set out hereinbelow. If you do not agree with these terms, do not use the Website.
                                </p>
                                <p>
                                It is clarified that the terms and conditions that are provided separately, form an integral part of your use of this Website and should be read in conjunction with this Privacy Policy.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
